module.exports = __webpack_public_path__ + "static/media/ts10.1437cc42.png";